module.exports = __webpack_public_path__ + "static/media/home.56e73e80.png";